import { useCallback } from "react";
import { useStudentsControllerCreate } from "@oneapp/data";

export type ExperienceRating =
  | "VERY_BAD"
  | "BAD"
  | "AVERAGE"
  | "GOOD"
  | "VERY_GOOD";

interface UseSubmitFeedbackParams {
  userId: string;
  examId: string;
}

export const useSubmitFeedback = ({
  userId,
  examId,
}: UseSubmitFeedbackParams) => {
  const { mutateAsync, isPending } = useStudentsControllerCreate({
    request: { clientName: "oneApp" },
  });

  const submitFeedback = useCallback(
    async (
      experience: ExperienceRating,
      comments: string[],
      feedback?: string,
    ) => {
      if (!userId || !examId) {
        throw new Error("Missing userId or examId for feedback submission.");
      }

      return mutateAsync({
        data: {
          userId,
          examid: examId,
          comments,
          feedback: feedback ?? "",
          experience,
        },
      });
    },
    [userId, examId, mutateAsync],
  );

  return { submitFeedback, isPending };
};
